import { ADD_EXPECTATION_MANAGEMENT_CASE } from 'redux/actions/expectationManagementActions';
import {
  ExpectationManagementActionType,
  ExpectationManagementState,
} from 'ts/types/expectation-management.types';

const initialState: ExpectationManagementState = {
  cases: [],
};

function expectationManagementReducer(
  state = initialState,
  action: ExpectationManagementActionType,
): ExpectationManagementState {
  switch (action.type) {
    case ADD_EXPECTATION_MANAGEMENT_CASE:
      return state.cases?.includes(action.payload.caseGuid)
        ? state
        : {
            ...state,
            cases: [...state.cases, action.payload.caseGuid],
          };
    default:
      return state;
  }
}

export default expectationManagementReducer;
